import Button from '@/components/base/Button';
import Reveal from '@/components/base/Reveal';

type ChecklistPromoProps = {
  variant?: 'home' | 'services';
};

/**
 * Promotes the complimentary Event Supplier Checklist.
 * `home` renders a full-width band; `services` renders a discreet inline note.
 */
export default function ChecklistPromo({ variant = 'home' }: ChecklistPromoProps) {
  if (variant === 'services') {
    return (
      <Reveal className="rounded-lg border border-background-200 bg-background-100 p-6 md:p-8">
        <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-5">
          <p className="text-base leading-relaxed text-foreground-700">
            <strong className="font-semibold text-foreground-950">Before you book any supplier:</strong>{' '}
            download our complimentary Event Supplier Checklist — the questions worth asking, and how
            to compare quotations.
          </p>
          <Button
            to="/free-event-checklist"
            variant="outline"
            size="md"
            icon="ri-download-2-line"
            className="shrink-0"
          >
            Get the free checklist
          </Button>
        </div>
      </Reveal>
    );
  }

  return (
    <section className="w-full px-4 md:px-8 lg:px-12 py-16 md:py-24 bg-background-50">
      <div className="max-w-content mx-auto">
        <Reveal className="rounded-lg border border-background-200 bg-[#1B1B1B] p-8 md:p-12">
          <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 items-center">
            <div className="lg:col-span-8">
              <span className="font-label text-xs uppercase tracking-widest2 text-primary-400">
                Free Guide
              </span>
              <h2 className="mt-4 font-heading text-2xl md:text-4xl leading-tight text-foreground-950">
                Planning an Event? Start With the Right Questions.
              </h2>
              <p className="mt-5 text-base leading-relaxed text-foreground-700 max-w-2xl">
                Before you book your suppliers, discover the 10 questions worth asking. Download our
                complimentary Event Supplier Checklist and make more confident choices.
              </p>
            </div>
            <div className="lg:col-span-4 lg:justify-self-end">
              <Button
                to="/free-event-checklist"
                variant="primary"
                size="lg"
                icon="ri-download-2-line"
                className="w-full lg:w-auto"
              >
                Get the free checklist
              </Button>
            </div>
          </div>
        </Reveal>
      </div>
    </section>
  );
}